export const TITLE_CHAR_LIMIT = 38;
export const SUB_TITLE_CHAR_LIMIT = 300;
export const API_ERROR_DESC = "Unable to fetch stocks";
export const NO_RESULTS_FOUND_ERROR_TITLE = "No Stocks Found";

export const CHAR_LIMITS = {
  STOCK_TITLE: 16,
  PRICE_VALUE: 14,
  TOTAL_CHANGE_INFO: 22,
} as const;

export const getStockColor = (status: string): string => {
  switch (status) {
    case "positive":
      return "greencolor";
    case "negative":
      return "redcolor";
    default:
      return "blackcolor";
  }
};
export const allStocksEntity = "topscrips";
export const marketTodayIndicesEntity = "mkt_today";
export const stocksTickerEntity = "ticker";

export type MarketCapFilter = "Large Cap" | "Mid Cap" | "Small Cap";

export const MARKET_CAP_FILTERS: MarketCapFilter[] = [
  "Large Cap",
  "Mid Cap",
  "Small Cap",
];

export const DEFAULT_MARKET_CAP: MarketCapFilter = "Large Cap";

/** PLP query param consumed by StockListingPage filters for market-cap selection. */
export const MARKET_CAP_QUERY_PARAM = "mktCapType";

export const textEllipsis = (
  text: string,
  charLimit: number,
  className?: string,
) => {
  if (!text?.trim() || text.trim().length <= charLimit) {
    return text;
  }

  const truncatedText = `${text
    .trim()
    .replace(/\r\n|\n/g, " ")
    .slice(0, charLimit)}...`;

  // Set tooltip if className is provided
  if (className) {
    const startTime = performance.now();
    const maxRetryTime = 500;

    const setTooltip = () => {
      const element = document.querySelector(`.${className}`);
      const elapsedTime = performance.now() - startTime;

      if (element) {
        element.setAttribute("title", text);
      } else if (elapsedTime < maxRetryTime) {
        requestAnimationFrame(setTooltip);
      }
    };

    requestAnimationFrame(setTooltip);
  }

  return truncatedText;
};
